import { useEffect, useRef, useState } from "react";
import { copy } from "../copy";
import { platformOf, topicAccount } from "../domain/accounts";
import { generateActions } from "../domain/tasks";
import { useApp } from "../state/store";
import type { Topic } from "../types";

export function GenerateMenu({ topic }: { topic: Topic }) {
  const app = useApp();
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLSpanElement>(null);
  const actions = generateActions(platformOf(app.state.accounts ?? [], topicAccount(topic)));

  useEffect(() => {
    if (!open) return;
    function onPointer(event: MouseEvent) {
      if (!root.current?.contains(event.target as Node)) setOpen(false);
    }
    window.addEventListener("mousedown", onPointer);
    return () => window.removeEventListener("mousedown", onPointer);
  }, [open]);

  return (
    <span className="menu" ref={root}>
      <button type="button" className="button ghost" aria-expanded={open} aria-haspopup="menu" onClick={() => setOpen((current) => !current)}>
        {copy.generate.menu}
      </button>
      {open ? (
        <span className="menu-pop" role="menu">
          {actions.map((action) => (
            <button
              key={action.type}
              type="button"
              role="menuitem"
              onClick={() => {
                app.createTask({
                  type: action.type,
                  accountId: topicAccount(topic),
                  topicId: topic.id,
                  platforms: topic.platforms,
                  direction: topic.title,
                  count: 1,
                });
                setOpen(false);
              }}
            >
              {action.label}
            </button>
          ))}
        </span>
      ) : null}
    </span>
  );
}
